export const ENABLE_PRICING_AND_PAYMENTS = true;